import { FileUpload } from 'shared/controls/file-upload';

export const AttachPdf = () => {
  return <FileUpload name={'files'} accept={'application/pdf'} />;
};
